import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

import axios from 'axios';

import { enum as bannerTypes } from '../../../../../enums/banner-types';

import getBanner from './custom-banners';

import './main.less';

import { Link } from 'react-router';

class Banner extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			index: 0
		};

		this.tick = this.tick.bind(this);
	}

	componentDidMount() {
		const banner = this.props.banner;

		if (banner && banner.content.list.length > 1) {
			this.interval = setInterval(this.tick, banner.content.interval);
		}
	}

	componentDidUpdate(prevProps) {
		const banner = this.props.banner;

		if (banner !== prevProps.banner) {
			clearInterval(this.interval);

			if (banner && banner.content.list.length > 1) {
				this.interval = setInterval(this.tick, banner.content.interval);
			}
		}
	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	tick() {
		this.setState(({ index }) => ({
			index: index === this.props.banner.content.list.length - 1 ? 0 : index + 1
		}));
	}

	render() {
		if (!this.props.banner) return null;

		const current = this.props.banner.content.list[this.state.index];

		if (current.type !== bannerTypes.custom) {
			const commonProps = {
				className: cn('banner-link', this.props.className),
				style: {
					backgroundImage: `url('${current.image}')`
				},
				onClick: () => {
					axios.post(`/v2/banners/${this.props.banner.id}/click`);
				}
			};

			if (current.link) {
				return (
					<Link {...commonProps} target={current.blank ? '_blank' : '_self'} to={current.link} />
				);
			}

			return (
				<div {...commonProps} />
			);
		} else {
			const Banner = getBanner(current.contentId);

			return (
				<Banner
					className={this.props.className}
					onClick={() => {
						axios.post(`/v2/banners/${this.props.banner.id}/click`);
					}}
				/>
			);
		}
	}
}

Banner.propTypes = {
	className: PropTypes.string,
	banner: PropTypes.shape({
		id: PropTypes.number,
		content: PropTypes.shape({
			list: PropTypes.arrayOf(
				PropTypes.oneOfType([
					PropTypes.shape({
						type: PropTypes.oneOf(['simple']),
						image: PropTypes.string.isRequired,
						link: PropTypes.string,
						blank: PropTypes.bool
					}),
					PropTypes.shape({
						type: PropTypes.oneOf(['custom']).isRequired,
						contentId: PropTypes.number.isRequired
					})
				]),
			).isRequired,
			interval: PropTypes.number
		}).isRequired
	})
};

export default Banner;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/banner/main.js